<template>
  <v-container fluid>
    <v-toolbar flat color="transparent" class="elevation-0">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            rounded
            color="primary"
            large
            @click="
              $router.push({
                name: 'Farm',
              })
            "
            v-bind="attrs"
            v-on="on"
          >
            <v-icon>mdi-home</v-icon>
          </v-btn>
        </template>
        <span>Dashboard</span>
      </v-tooltip>
      <v-toolbar-title class="font-weight-black">
        Admin Dashboard
      </v-toolbar-title>
      <v-spacer />
    </v-toolbar>
    <v-row>
      <v-col v-for="menu in menus" :key="menu._id" cols="12" md="6" lg="3">
        <v-card class="mx-auto">
          <v-card-title>
            {{ menu.title }}
            <v-spacer />
          </v-card-title>
          <v-card-subtitle>
            {{ menu.subTitle }}
          </v-card-subtitle>

          <v-card-actions>
            <v-btn
              @click="
                $router.push({
                  name: menu.path,
                })
              "
              color="success"
              outlined
              rounded
              text
            >
              Dashboard
            </v-btn>
            <v-spacer />
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    menus: [
      {
        id: 1,
        title: "ผู้ใช้งาน",
        subTitle: "จัดการข้อมูลผู้ใช้งาน",
        path: "User",
      },
      {
        id: 2,
        title: "อุปกรณ์",
        subTitle: "ข้อมูลอุปกรณ์ที่สามารถใช้งานได้ในระบบ",
        path: "DeviceRegister",
      },
      {
        id: 3,
        title: "อุปกรณ์ทั้งหมด",
        subTitle: "รายการมูลอุปกรณ์ที่ใช้งานในระบบ",
        path: "Device",
      },
    ],
  }),
};
</script> 
